import React from 'react';
import { connect } from 'react-redux';
import { Control, Form, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import BaseDetailScreen from '../../BaseDetailScreen';
import LabeledRow from '../components/LabeledRow';
import InputRow from '../components/InputRow';
import InputField from '../../Forms/Controls/Field';
import CheckOption from '../components/CheckOption';
import { formatCurrency } from '../../Currency';
import Button from '../../Button';
import {
  baseExternalOfferOrderPath,
  externalOfferOrderAmountPath,
  externalOfferOrderDisclosuresPath,
  externalOfferOrderTransferPath,
} from '../../Forms/Schemas/baseRrf';
import {
  fetchAccountCashBalanceWithOfferingOrders,
} from '../../../actions';
import { InlineTip } from '../../../components/Tooltip';

import './styles.css';


const getShareInc = ({
  pricePerShare,
  minimumInvestIncCurrencyAmt,
  minimumInvestShareIncrQty,
}) => {
  if (pricePerShare && minimumInvestIncCurrencyAmt) {
    return Math.max(
      Math.ceil(minimumInvestIncCurrencyAmt / pricePerShare),
      minimumInvestShareIncrQty,
    );
  }
  return minimumInvestShareIncrQty;
};

const RestrictedPersonCheckbox = props => (
  <CheckOption {...props} styles={{ main: 'mainAlt' }}>
    By checking I am not considered a&nbsp;
    <Link
      styleName="disclaimerLink"
      to={`/external-invest/${props.offerId}/restricted-person`}
    >
      &quot;restricted person&quot;
    </Link>
    &nbsp;and am eligible to participate in this offering
  </CheckOption>
);


class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  async componentDidMount() {
    this.props.fetchAccountCashBalanceWithOfferingOrders(this.props.currentAccount);

    const { requestedDollarAmount } = get(this.props, externalOfferOrderAmountPath);
    if (requestedDollarAmount) {
      // await this.overAssetRange(requestedDollarAmount, this.props.hasMaximumInvest);
      // this.insideAssetRange(requestedDollarAmount, this.props.hasMaximumInvest);
    }
  }

  async componentWillReceiveProps(newProps) {
    const newRDA = get(newProps, `${externalOfferOrderAmountPath}.requestedDollarAmount`);
    const oldRDA = get(this.props, `${externalOfferOrderAmountPath}.requestedDollarAmount`);

    if (newRDA !== oldRDA) {
      // await this.overAssetRange(newRDA, this.props.hasMaximumInvest);
      // this.insideAssetRange(newRDA, this.props.hasMaximumInvest);
    }
  }

  render() {
    const {
      externalOfferOrderForm,
      offer,
      onNext,
      resetAll,
      setOfferId,
      offerOrderAmount,
    } = this.props;
      // if a user loads a order form for a new offer then reset
      // the order form for the previous offer
    if (!externalOfferOrderForm.offerId || (externalOfferOrderForm.offerId !== offer.id)) {
      resetAll();
      setOfferId(offer.id);
    }

    const { isConditional } = this.props;
    const pageHeading = isConditional ? 'Conditional Order' : 'Order';

    const minShareQuantity = Math.ceil((offer.minimumInvestCurrencyAmt / offer.pricePerShare), 10);
    const shareIncrement = getShareInc(offer);
    const radioStyle = {
      marginRight: '10px',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      display: 'inline-block',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      width: '20px',
      height: '20px',
      top: '4px',
      position: 'relative',
    };
    const quantity = {
      model: '.quantity',
      RRFComp: Control,
      control: {
        component: InputRow,
        mask: createNumberMask({
          prefix: '',
          includeThousandsSeparator: true,
        }),
        changeAction: (model, value) => (dispatch) => {
          const cleanedVal = value.replace(/\D/g, '') || 0;
          dispatch(actions.change(model, cleanedVal));
          dispatch(actions.change(
            `${externalOfferOrderAmountPath}.requestedDollarAmount`,
            (cleanedVal * offer.pricePerShare),
          ));
        },
        errors: {
          required: val => !val,
          noPartialShares: val => val && val.includes('.'),
          mininumInvestment: val => val && !val.includes('.') && !(val >= minShareQuantity),
          shareInc: (val) => {
            const amountAboveMinInvest = val - minShareQuantity;
            if (amountAboveMinInvest > 0 && amountAboveMinInvest % shareIncrement) {
              return true;
            }
            return false;
          },
        },
        mapProps: {
          label: 'Share Quantity',
          placeholder: '0',
          value: get(externalOfferOrderForm, 'externalOfferOrderAmount.quantity'),
        },
      },
      error: {
        messages: {
          required: 'Please enter an order quantity.',
          noPartialShares: 'Partial shares are not currently being accepted',
          mininumInvestment: `The minimum investment quantity is ${minShareQuantity}`,
          shareInc: `The investment quantity must be in increments of ${shareIncrement}`,
        },
      },
    };

    const totalInvestmentAmount = {
      model: '.totalInvestment',
      RRFComp: Control,
      control: {
        component: InputRow,
        mask: createNumberMask({
          prefix: '$',
          includeThousandsSeparator: true,
        }),
        changeAction: (model, value) => (dispatch) => {
          const cleanedVal = value.replace(/\D/g, '') || 0;
          dispatch(actions.change(model, cleanedVal));
          dispatch(actions.change(`${externalOfferOrderAmountPath}.requestedDollarAmount`, cleanedVal));
        },
        errors: {
          required: val => !val,
          mininumInvestment: val => val && !val.includes('.') && !(val >= offer.minimumInvestCurrencyAmt),
        },
        placeholder: '0',
        mapProps: {
          label: 'Total Investment',
          placeholder: '0',
          value: get(externalOfferOrderForm, 'externalOfferOrderAmount.totalInvestment'),
        },
      },
      error: {
        messages: {
          required: 'Please enter total investment amount.',
          mininumInvestment: `The minimum investment amount is ${formatCurrency(offer.minimumInvestCurrencyAmt)}`,
        },
      },
    };

    const restrictedPerson = {
      model: '.unrestricted',
      RRFComp: Control.checkbox,
      control: {
        component: RestrictedPersonCheckbox,
        errors: {
          required: val => !val,
        },
        mapProps: {
          isToggle: true,
          offerId: offer.id,
        },
      },
      error: {
        messages: {
          required: 'Please confirm you are not restricted from investing in this offer.',
        },
      },
    };
    const underAssetCheck = {
      model: '.accreditation',
      RRFComp: Control.radio,
      value: 'NOT_ACCREDITED',
    };
    const accreditedPerson = {
      model: '.accreditation',
      RRFComp: Control.radio,
      value: 'ACCREDITED',
    };
    const nonAccredited = "An investor who does not meet the net worth requirements for an accredited investor under the Securities & Exchange Commission's Reg D.  A non-accredited investor is one who has a net worth of less than $1 million (including spouse) and who earned less than $200,000 annually ($300,000 with spouse) in the current calendar year.";
    const accredited = "To be considered an accredited investor, one must have a net worth of at least $1,000,000, excluding the value of one's primary residence, or have income of at least $200,000 each year for the last two years (or $300,000 combined income if married) and have the expectation to make the same amount in the current calendar year.";
    return (
      <BaseDetailScreen
        pageHeading={pageHeading}
        pageSubheading={offer.name}
        backTo={`/offers/${offer.id}`}
        backLabel="Offer Details"
      >
        <div styleName="main">
          <Form
            model={externalOfferOrderAmountPath}
            onSubmit={onNext}
            styleName="amountForm"
          >
            <LabeledRow
              isCurrency
              label="Minimum Investment"
              value={offer.minimumInvestCurrencyAmt}
            />
            <div styleName="breakLinePadded" />
            {
              isConditional ?
                <LabeledRow
                  label="Share Range"
                  value={`${formatCurrency(offer.minSharePrice)} - ${formatCurrency(offer.maxSharePrice)}`}
                /> :
                <LabeledRow
                  isCurrency
                  label="Share Price"
                  value={offer.pricePerShare}
                />
            }
            {
              isConditional ?
                <div style={{ marginBottom: 0 }}>
                  <div styleName="breakLineTotal" />
                  <InputField
                    key={totalInvestmentAmount.model}
                    fieldProps={totalInvestmentAmount}
                  />
                </div> :
                <InputField
                  key={quantity.model}
                  fieldProps={quantity}
                />
            }
            {
              !isConditional ?
                <div>
                  <div styleName="breakLineTotal" />
                  <LabeledRow
                    isCurrency
                    label="Total Investment"
                    value={get(externalOfferOrderForm, 'externalOfferOrderAmount.requestedDollarAmount')}
                    styleName={`externalInvestAmountOptionRadio${accreditedPerson.value === offerOrderAmount.accredited ? 'Active' : ''}`}
                  />
                </div> : null
            }
            { offer.allowRestrictedPersons ?
              <div>
                <div styleName="breakLineTotal" />
                <InputField
                  key={restrictedPerson.model}
                  fieldProps={restrictedPerson}
                  id={restrictedPerson.model}
                />
              </div>
              : null
            }
            {/* <div styleName="accreditedTitle"> */}
            {/*  I hereby represent and warrant that I meet the qualifications to purchase Shares because: */}
            {/* </div> */}
            <div styleName="externalInvestAmountOption" style={{ paddingTop: '30px' }} >
              <Control.radio
                {...underAssetCheck.control}
                key={underAssetCheck.model}
                model={underAssetCheck.model}
                id={underAssetCheck.value}
                value={underAssetCheck.value}
                styleName={`externalInvestAmountOptionRadio${underAssetCheck.value === offerOrderAmount.accreditation ? 'Active' : ''}`}
                style={radioStyle}
              />
              <label styleName="externalInvestAmountOptionLabel" htmlFor={underAssetCheck.value}>
                <span style={{ display: 'inline' }}>
                  I am a&nbsp;<InlineTip styleType text={nonAccredited}>non-accredited</InlineTip>&nbsp;investor and aggregate purchase price for the Securities I am purchasing in the Offering does not exceed 10% of my net worth or annual income, whichever is greater.
                </span>
              </label>
            </div>
            {/* <div> */}
            {/*  <InputField */}
            {/*    key={accreditedPerson.model} */}
            {/*    fieldProps={accreditedPerson} */}
            {/*    id={accreditedPerson.model} */}
            {/*  > */}
            {/*    I am an accredited investor. <Tooltip styles={{ display: 'inline-block', marginLeft: '8px' }} text="Cash available is the sum of your cash balance and pending transfers">{accredited}</Tooltip> */}
            {/*  </InputField> */}
            {/* </div> */}
            <div styleName="externalInvestAmountOption" >
              <Control.radio
                {...accreditedPerson.control}
                key={accreditedPerson.model}
                model={accreditedPerson.model}
                id={accreditedPerson.value}
                value={accreditedPerson.value}
                styleName={`externalInvestAmountOptionRadio${accreditedPerson.value === offerOrderAmount.accreditation ? 'Active' : ''}`}
                style={radioStyle}
              />
              {/* <label styleName="externalInvestAmountOptionLabel" htmlFor={accreditedPerson.value}> */}
              {/*  I am an accredited investor. <Tooltip styles={{ display: 'inline-block', marginLeft: '8px' }} text="Cash available is the sum of your cash balance and pending transfers">{accredited}</Tooltip> */}
              {/* </label> */}
              <label styleName="externalInvestAmountOptionLabel" style={{ display: 'contents' }} htmlFor={accreditedPerson.value}>
                I am an&nbsp;<InlineTip styleType text={accredited}>accredited</InlineTip>&nbsp;investor.
              </label>
            </div>
            <div styleName="submitButtonContainer">
              <Button type="submit">
                <div>Review</div>
              </Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}

Component.displayName = 'SelectInvestmentAmount';

const mapStateToProps = state => ({
  currentAccount: state.currentAccount,
  cashBalance: get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades'),
  pendingTransfers: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.pendingTransfersAvailableForOfferings')),
  finances: get(state, 'user.data.finances'),
  isAccredited: get(state, 'isAccredited'),
  offerOrderAmount: get(state, externalOfferOrderAmountPath),
});

const mapDispatchToProps = dispatch => ({
  resetAll: async () => {
    await dispatch(actions.reset(baseExternalOfferOrderPath));
    await dispatch(actions.reset(externalOfferOrderAmountPath));
    await dispatch(actions.reset(externalOfferOrderDisclosuresPath));
    await dispatch(actions.reset(externalOfferOrderTransferPath));
  },
  setValidity: async val => dispatch(actions.setValidity(`${externalOfferOrderAmountPath}.requestedDollarAmount`, val)),
  setOfferId: async offerId => (dispatch(actions.change(`${baseExternalOfferOrderPath}.offerId`, offerId))),
  fetchAccountCashBalanceWithOfferingOrders: (...args) =>
    (dispatch(fetchAccountCashBalanceWithOfferingOrders(...args))),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/InvestmentViews/SelectInvestmentAmount.js